module.exports = __webpack_public_path__ + "media/images/ic-esqueci-a-senha-26c2f7ca872fb71ecc887657b42592ec.svg";